export const certificates = [
  {
    name: 'Oracle Certified Professional Java SE 17 Developer.webp',
    file: require('assets/certificates/Oracle Certified Professional Java SE 17 Developer.webp'),
  },
  {
    name: 'Azure Developer Associate.webp',
    file: require('assets/certificates/Azure Developer Associate.webp'),
  },
  {
    name: 'Azure Fundamentals.webp',
    file: require('assets/certificates/Azure Fundamentals.webp'),
  },
  {
    name: 'Microservices with Node JS and React - Stephen Grider.webp',
    file: require('assets/certificates/Microservices with Node JS and React - Stephen Grider.webp'),
  },
  {
    name: 'Microservices Architecture and Implementation on .NET 5 - Mehmet Ozkaya.webp',
    file: require('assets/certificates/Microservices Architecture and Implementation on .NET 5 - Mehmet Ozkaya.webp'),
  },
  {
    name: 'The Modern React Bootcamp - Colt Steele.webp',
    file: require('assets/certificates/The Modern React Bootcamp - Colt Steele.webp'),
  },
  {
    name: 'Angular The Complete Guide 2022 - Maximilian Schwarzmüller.webp',
    file: require('assets/certificates/Angular The Complete Guide 2022 - Maximilian Schwarzmüller.webp'),
  },
  {
    name: 'Complete guide to building an app with Net Core and React - Neil Cummings.webp',
    file: require('assets/certificates/Complete guide to building an app with Net Core and React - Neil Cummings.webp'),
  },
  {
    name: 'The Web Developer Bootcamp 2022 - Colt Steele.webp',
    file: require('assets/certificates/The Web Developer Bootcamp 2022 - Colt Steele.webp'),
  },
  {
    name: 'The Complete Ruby on Rails Developer Course - Mashrur Hossain.webp',
    file: require('assets/certificates/The Complete Ruby on Rails Developer Course - Mashrur Hossain.webp'),
  },
  {
    name: 'Vue The Complete Guide - Maximilian Schwarzmüller.webp',
    file: require('assets/certificates/Vue The Complete Guide - Maximilian Schwarzmüller.webp'),
  },
  {
    name: 'Scrum Fundamentals Certified.webp',
    file: require('assets/certificates/Scrum Fundamentals Certified.webp'),
  },
];
